var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h100 text-c"},[_c('cnd-icon',{staticClass:"download-icon pointer",attrs:{"name":"cnd-delete"},on:{"click":_vm.deleteParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }